module.exports = __webpack_public_path__ + "static/media/3DPPA1.33ae7cca.jpg";